import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 20V10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 21v-5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 10h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 18h8", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Backpack";
const Backpack = memo(themed(Icon));
export {
  Backpack
};
//# sourceMappingURL=backpack.js.map
